module.exports = "//static.hsappstatic.net/ContentComponents/static-2.67510/img/blog-post-zero.png"